import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import store from './store'
import VueWamp from 'vue-wamp/dist/vue-wamp.esm'

Vue.config.productionTip = false

Vue.use(VueWamp, {
  debug: false, // Logs will be written to the console
  url: process.env.VUE_APP_WS_URL,
  realm: 'arbatravel',
  onopen: function(session, details) {
    console.log('WAMP connected', session, details)
  },
  onclose: function(reason, details) {
    console.log('WAMP closed: ' + reason, details)
  }
})

Vue.prototype.$alert = {
  success (text) {
    store.commit('showAlert', { color: 'success', text: text })
  },
  failed (text) {
    store.commit('showAlert', { color: 'red', text: text })
  }
}

Vue.prototype.$showAlert = function (color, text) {
  store.commit('showAlert', { color: color, text: text })
}

const VERTICALS = {
  JT: 'Joined Tour',
  PT: 'Private Tour',
  ST: 'Short Tour',
  VISA: 'VISA',
  TIX: 'Tickets',
  TPORT: 'Transport',
  TP: 'Travel Products',
  XTVT: 'Activities'
}

const PROVIDER = {
  ARBA: 'ARBA Travel',
  GBTX: 'Global Tix',
  NNTA: 'Nanta',
  PLCM: 'PlaceM',
  TCRT: 'Trip Carte',
  CBTV: 'Cebu Travel',
  KLOK: 'Klook',
  ONVC: 'Onvacay'
}

const COUNTRYLIST = require('country-list');

Vue.filter('verticalView', value => {
  return VERTICALS[value]
})

Vue.filter('providerView', value => {
  return PROVIDER[value]
})

Vue.filter('getCountryName', value => {
  return COUNTRYLIST.getName(value)
})

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
